import * as React from 'react';
import { Outside } from '@cian/ui-kit';

import { IUseSuggestProps, useSuggest } from './utils';
import { usePreventSubmitOnEnter } from '../../utils/form';
import { ISuggestion, SuggestField } from '../../packages/SuggestField';

export interface ISuggestContainerProps<T extends ISuggestion> extends IUseSuggestProps<T> {
  placeholder: string;
  error?: string;
  notFoundText: string;
  onBlur?: () => void;
}
export function SuggestFieldContainer<T extends ISuggestion>(props: ISuggestContainerProps<T>) {
  const { placeholder, error, notFoundText, value, onBlur } = props;

  const { suggestions, onSuggestionValueChange, handleItemClick, isFetching, hideSuggest, isSuggestShown } =
    useSuggest(props);

  const onKeyPress = usePreventSubmitOnEnter();

  return (
    <Outside onOutside={hideSuggest}>
      <SuggestField
        isLoading={isFetching}
        placeholder={placeholder}
        inputValue={value}
        onKeyPress={onKeyPress}
        suggestions={suggestions}
        isPopupShown={isSuggestShown}
        onChange={onSuggestionValueChange}
        onItemClick={handleItemClick}
        error={error}
        notFoundText={notFoundText}
        onBlur={onBlur}
      />
    </Outside>
  );
}

SuggestFieldContainer.displayName = 'SuggestFieldContainer';
